import { FunctionComponent, SVGProps } from "react"

// 退货期限提示图标
const ReturnWindowIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33301 11.9999H10.6663M5.33301 11.9999C5.33301 13.4727 6.52692 14.6666 7.99967 14.6666C9.47243 14.6666 10.6663 13.4727 10.6663 11.9999M5.33301 11.9999V10.5257C5.33301 10.0899 5.11074 9.6908 4.79403 9.39134C3.89435 8.54064 3.33301 7.33583 3.33301 5.99992C3.33301 3.42259 5.42235 1.33325 7.99967 1.33325C10.577 1.33325 12.6663 3.42259 12.6663 5.99992C12.6663 7.33583 12.105 8.54064 11.2053 9.39134C10.8886 9.6908 10.6663 10.0899 10.6663 10.5257V11.9999M6.66634 5.99992L7.99967 7.33325M7.99967 7.33325L9.33301 5.99992M7.99967 7.33325V11.9999"
        fill="none"
        style={{ fill: "none" }}
        stroke="#00527C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ReturnWindowIcon
